
import ModalView from 'common-views/ModalView';
import template from 'common-views/select-file-modal.ejs';

class SelectFileModal extends ModalView {

    initialize(opts){
        this.message = "The following items has been successfully imported:";
        if (opts && opts.width) {
            this.width = opts.width;
        }

        super.initialize();

        if (opts) {
            this.itemName = 'App version ' + opts.itemName;
            this.dependencies = opts.dependencies;

            if (opts.message) {
                this.message = opts.message;
                this.itemName = opts.itemName;
            }
            
        }else {
            this.itemName = '';
            this.dependencies = '';
        }
    }

    activateNextButton(){
        $('button.selectFileNext').button("enable")
    }

    showSection() {
        if (this.itemName !== '' && this.dependencies!== '') {
            $('.file-select-step-1').addClass('hide');
            $('.file-select-step-2').removeClass('hide');
            $('button.selectFileNext').addClass('hide');
            $('button.selectFileDone').removeClass('hide');
            $('button.selectFileCancel').button("disable");
        } else {
            $('.file-select-step-1').removeClass('hide');
            $('.file-select-step-2').addClass('hide');
            $('button.selectFileDone').addClass('hide');
        }
    }

    bindEvents(){
        $('#file-select').on('change', (e) => {
            $('#file-name').val(e.target.value.split( '\\' ).pop() );
            this.activateNextButton();
        });
    }

    render(){
        const _this = this;
        return new Promise((resolve, reject) => {
            const settings = this.settings;

            settings.buttons = [
                {
                    text: 'Back',
                    'class':'selectFileBack',
                    disabled: true,
                    click: () => { }
                },
                {
                    text: 'Next',
                    'class':'selectFileNext',
                    disabled: true,
                    click: () => {
                        const file = {name: $('#file-name').val(),
                                    file: $('#file-select')[0].files[0]};
                        resolve(file);
                        _this.closeModal();
                    }
                },
                {
                    text: 'Done',
                    'class':'selectFileDone',
                    click: () => {
                        resolve('Done');
                        _this.closeModal();
                    }
                },
                {
                    text: 'Cancel',
                    'class':'selectFileCancel',
                    click: () => {
                        resolve('Unauthorized');
                        _this.closeModal();
                    }
                }
            ];

            this.$el.html(template({itemName:this.itemName, 
                                    dependencies:this.dependencies, 
                                    message: this.message
                                }));
            super.render();
            this.showSection();
            this.bindEvents();

            return this;
        });
    }
}

export default SelectFileModal;